import React from "react"

function Minus({ size }) {
    return (
        <svg height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 11H3V12.5H21V11Z" fill="currentColor" />
        </svg>
    )
}
export default Minus